import * as React from "react";

const IconLinkMinus: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" width="11" height="1" viewBox="0 0 11 1" fill="currentColor"><polygon fill="currentColor" points="9.75 .875 9.375 .875 .375 .875 0 .875 0 .125 .375 .125 9.375 .125 9.75 .125"  transform="translate(.375)"/></svg>;
};

export default React.memo(IconLinkMinus);
